import * as Sentry from '@sentry/react';

Sentry.init({
  release: __COMMIT_SHA__,
  dsn: 'https://7a34ad732588cc563edc149af5fb5330@o25257.ingest.us.sentry.io/4510120074739712',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0, // TODO: Probably reduce this in production, let's see how it goes for now
});
